import { DefaultRootState, useSelector } from 'react-redux';
import { DependencyList } from 'react';
import { useMap } from './map';

export function useMapSelector<TState = DefaultRootState, TSelected = unknown, TOutput = unknown>(
  selector: (state: TState) => TSelected[],
  callback: (item: TSelected) => TOutput,
  deps?: DependencyList
) {
  return useMap(useSelector(selector), callback, deps);
}

